import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { 
    Flex, Box, Center, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel, Image,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Select, useToast
} from '@chakra-ui/react';
import { MdSave, MdThumbUpAlt } from 'react-icons/md';
import {faker} from '@faker-js/faker';
import { Form, Field } from 'react-final-form';
import { API_SUB_URL_COMPANY, PENDING_STATUS, EXTEND_COMPANY, PRICING_LIST, ERROR_CODES } from "../../../constants"
import { displayConfirmAlert } from '../../utils';

function ExtendCompanyModal({ 
    initialRef, isOpen, onClose, register_type, company_id
}) {
    const [companyList, setCompanyList] = useState([]);
    const [ isProcessing, setIsProcessing ] = useState(false);
    const mounted = useRef();
    const toast = useToast();

    useEffect(() => {
        if(!mounted.current) {
            getCompanyList();
            mounted.current = true;
        }
    });

    const getCompanyList = async() => {
        try
        {
            const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}${API_SUB_URL_COMPANY}?order_by=name&&order_dir=asc`, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            if(response.data) {
                setCompanyList(response.data)
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    const validate = (values) => {
        const errors = {};

        if(!values.company_id) {
            errors.company_id = "Required";
        }
        
        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        try
        {
            const firstCompany = companyList.find(item => item.id === parseInt(values.company_id))
            const { id, name, email, active_expired } = firstCompany || {};

            const ORDER_CODE = faker.number.int({max: 9999999999});
            const AMOUNT = PRICING_LIST[register_type]?.amount;;
            const DESCRIPTION = `Phí gia hạn ${ORDER_CODE}`;

            const response = await axios.post(`${process.env.REACT_APP_WEB_SERVER_URL}/create_payment_link_payos`, {
                orderCode: ORDER_CODE,
                amount: AMOUNT,
                description: DESCRIPTION,
                returnUrl: `${process.env.REACT_APP_URL}/payment_response/${EXTEND_COMPANY}/success`,
                cancelUrl: `${process.env.REACT_APP_URL}/payment_response/${EXTEND_COMPANY}/failed`
            }, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            if(response.data?.status === 200) {
                // add new payment
                await axios.post(`${process.env.REACT_APP_WEB_SERVER_URL}/payments`, {
                    company_id: id,
                    payment_type: EXTEND_COMPANY,
                    order_code: ORDER_CODE,
                    amount: AMOUNT,
                    description: DESCRIPTION,
                    status: PENDING_STATUS,
                    extra_data: {
                        name, 
                        email, 
                        active_expired,
                        register_type
                    },
                }, {
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                // open link to pay
                window.open(response.data?.data.checkoutUrl, "_self");
                onClose();
            } else {
                displayConfirmAlert(`Tạo thanh toán không thành công. Quý khách vui lòng thử lại hoặc liên hệ với phòng khám để được hỗ trợ!`);
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }

        setIsProcessing(false);
    }

    return (
        <React.Fragment>
            <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="md">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        GIA HẠN PHÒNG KHÁM
                    </ModalHeader>
                    <ModalCloseButton />

                    <ModalBody pb={2}>
                        <Form
                            onSubmit={onSubmit}
                            validate={validate}
                            initialValues={{
                                company_id
                            }}
                            render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                                return (
                                    <form onSubmit={handleSubmit}>
                                        <Flex direction="column">
                                            <Field name="company_id">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel>Chọn phòng khám</FormLabel>
                                                        <Select {...input} placeholder='Chọn Phòng khám'>
                                                            {
                                                                companyList.map(item => (
                                                                    <React.Fragment key={item.id}>
                                                                        <option value={item.id}>{item.name}</option>
                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Button my={4} colorScheme='green' width="full" type='submit' isDisabled={!valid}
                                                isLoading={isProcessing}
                                                loadingText="Đang xử lý"
                                            >
                                                Gia hạn
                                            </Button>
                                        </Flex>
                                    </form>
                                )
                            }}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            {
                isProcessing &&
                <Center>
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="200px" zIndex={9999}>
                        <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">Đang xử lý ...</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }
        </React.Fragment>
    )
}

export default ExtendCompanyModal;